import UserPage from "flarum/forum/components/UserPage";
import Link from "flarum/components/Link";
/* global m */

const compareNames = (a, b) => {
  var nameA = a.name.toUpperCase(); // ignore upper and lowercase
  var nameB = b.name.toUpperCase(); // ignore upper and lowercase
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  // names must be equal
  return 0;
};
const compareAnswers = (a, b) => {
  return b.postsPerTag - a.postsPerTag;
};

const answerMultiplication = 3;
const bestAnswerMultiplication = 5;
const questionMultiplication = 2;
const makeDiscussionSkill = (n) => parseInt(n) * questionMultiplication;
const makeAnswerSkill = (n) => parseInt(n) * answerMultiplication;
const makeBestAnswerSkill = (n) => parseInt(n) * bestAnswerMultiplication;

export default class ProfessionalAchievementsPane extends UserPage {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;

    this.fields = [];
    this.answers = {};

    this.loadUser(m.route.param("id"));
  }

  content() {
    // console.log(this.fields);
    return m(".Professional-Achievemens", [
      m(
        ".Fields",
        this.fields
          .sort(compareAnswers)
          .map(
            ({ name, color, icon, slug, discussionsPerTag, postsPerTag, bestAnswersCount }) => {
              const skill = makeDiscussionSkill(discussionsPerTag) + makeAnswerSkill(postsPerTag - discussionsPerTag) + makeBestAnswerSkill(bestAnswersCount);
              if (!color) {
                return;
              }
              return (
                <div
                  className="professional-achievemens-tag-item"
                  style={"--tag-color:" + color}
                >
                  <div className="professional-achievemens-tag-desc">
                    <Link href={"/t/" + slug}>
                      <i className={icon} />
                      <span>{name}</span>
                    </Link>
                  </div>
                  <div className="proessional-achievements-tag-stats">
                    <span className="questions">
                      {app.translator.trans("tolyod-advdiscus.forum.user_profile.professional_skill", { skill })}
                    </span>
                  </div>
                </div>
              );
            }
          )
      ),
    ]);
  }

  load(user) {
    console.log(user.id());
    const apiUrl = app.forum.attribute("apiUrl");
    const uid = user.id();
    app
      .request({
        method: "GET",
        url: `${apiUrl}/professional_achievements/${uid}`
      })
      .then(this.parseResponse.bind(this));
  }

  show(user) {
    this.load(user);

    super.show(user);
  }

  parseResponse({ jsonapi }) {
    this.answers = {};
    this.fields = jsonapi.stats;

    this.loading = false;
    m.redraw();
  }
}
